module.exports = __webpack_public_path__ + "img/btn_record.9a3ab079.svg";